import { render, staticRenderFns } from "./not_found.vue?vue&type=template&id=2aad122f&scoped=true"
import script from "./not_found.vue?vue&type=script&lang=js"
export * from "./not_found.vue?vue&type=script&lang=js"
import style0 from "./not_found.vue?vue&type=style&index=0&id=2aad122f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../.nvm/versions/node/v22.19.0/lib/node_modules/@vue/cli-service-global/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aad122f",
  null
  
)

export default component.exports